<template>
  <div>
    <action-bar></action-bar>
    <main class="content">
      <div v-if="keyTheme">
        <h1>
          Themenschwerpunkt bearbeiten
          <br>
          <small class="text-muted">{{keyTheme.name.text}}</small>
        </h1>
        <ul class="nav nav-tabs">
          <li class="nav-item">
            <router-link
              class="nav-link"
              :to="{name: 'key-theme-edit', params: {keyThemeId: $route.params.keyThemeId}}"
              exact
            >Generelle Texte</router-link>
          </li>
          <li class="nav-item">
            <router-link
              class="nav-link"
              :to="{name: 'key-theme-chapter-list', params: {keyThemeId: $route.params.keyThemeId}}"
              exact
            >Synthese Kapitel</router-link>
          </li>
          <li class="nav-item">
            <router-link
              class="nav-link"
              :to="{name: 'key-theme-synthesis-end-event', params: {eventId: keyTheme.synthesis.endEvent.id}}"
              exact
            >Synthese Schlussveranstaltung</router-link>
          </li>
        </ul>
        <div class="tab-content">
          <router-view
            class="tab-pane fade show active"
            entity="keyTheme"
            :data="keyTheme"
            :event="keyTheme.synthesis.endEvent"
          />
        </div>
      </div>
      <loading v-else></loading>
    </main>
  </div>
</template>
<script>
import moment from "moment";

export default {
  asyncComputed: {
    async keyTheme() {
      if (!this.$route.params.keyThemeId) return {};

      const {
        data: { result: keyTheme }
      } = await axios.get(
        "/api/" +
          store.state.language +
          "/key_theme/" +
          this.$route.params.keyThemeId
      );

      const {
        data: { result: synthesis }
      } = await axios.get(
        "/api/" + store.state.language + "/synthesis/" + keyTheme.synthesisId
      );

      const {
        data: { result: endEventResults }
      } = await axios.get(
        "/api/" + store.state.language + "/event/" + synthesis.endEvent.id + "/results"
      );

      keyTheme.synthesis = synthesis;
      keyTheme.synthesis.endEvent.results = endEventResults;

      if (keyTheme.synthesis.availableFrom)
        keyTheme.synthesis.availableFrom = moment(
          keyTheme.synthesis.availableFrom.date
        );

      if (keyTheme.synthesis.disclaimerDate)
        keyTheme.synthesis.disclaimerDate = moment(
          keyTheme.synthesis.disclaimerDate.date
        );

      if (keyTheme.synthesis.endEvent.date)
        keyTheme.synthesis.endEvent.date = moment(
          keyTheme.synthesis.endEvent.date.date
        );

      return keyTheme;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/admin/key_theme/Edit.vue